import loadable from '@loadable/component'

export default [
  {
    path: '/worldCup',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-worldCup-list" */ '~/pages/worldCup/pages/list'
        )
    ),
  },
  {
    path: '/worldCup/record',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-worldCup-record" */ '~/pages/worldCup/pages/record'
        )
    ),
  },
  {
    path: '/worldCup/vote',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-worldCup-vote" */ '~/pages/worldCup/components/vote/page'
        )
    ),
  },
  {
    path: '/worldCup/:id',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-worldCup-detail" */ '~/pages/worldCup/pages/detail'
        )
    ),
  },
  {
    path: '/worldCup/banner/:id',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-worldCup-banner" */ '~/pages/worldCup/pages/banner'
        )
    ),
  },
]
